import { render } from "./FindCenterContactPersons.vue?vue&type=template&id=1b8c07cb"
import script from "./FindCenterContactPersons.vue?vue&type=script&lang=js"
export * from "./FindCenterContactPersons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__